import Card from '@/components/Card';
import { ConditionalRender } from '@/components/ui/ConditionalRender';
import { useAdditionalInfoContext } from '@/features/v2/lib/additionalInfo';
import { useStepper } from '@/features/v2/lib/stepper';
import { MultiSelectBeforeAccidentRepaired } from '@/features/v2/vehicle-damage/components/MultiSelectBeforeAccidentRepaired';
import { MultiSelectDamageBeforeAccident } from '@/features/v2/vehicle-damage/components/MultiSelectDamageBeforeAccident';
import { SelectOriginalPartsUsedForRepair } from '@/features/v2/vehicle-damage/components/OriginalPartsUsedForRepair';
import {
  RadioGroupNoRepairableDamage,
  UNREPAIRABLE_DAMAGES_BEFORE_ACCIDENT,
} from '@/features/v2/vehicle-damage/components/RadioGroupNoRepairableDamage';
import {
  RadioGroupPreAccidentRepairs,
  REPAIRS_BEFORE_ACCIDENT,
} from '@/features/v2/vehicle-damage/components/RadioGroupPreAccidentRepairs';
import { RadioGroupVehicleOwner } from '@/features/v2/vehicle-damage/components/RadioGroupVehicleOwner';

export const SurveyOnePartTwo = () => {
  const { innerStep, step } = useStepper();

  const { additionalInfo } = useAdditionalInfoContext();

  return (
    <>
      {(innerStep >= 3 || step > 0) && (
        <>
          {!additionalInfo.isVehicleSold && (
            <Card>
              <RadioGroupVehicleOwner />
            </Card>
          )}
          <ConditionalRender
            when={(val) =>
              val.still_vehicle_owner || additionalInfo.isVehicleSold
            }
          >
            <Card>
              <RadioGroupNoRepairableDamage />
              <ConditionalRender
                when={(val) =>
                  val.unrepairable_damages_before_accident ===
                  UNREPAIRABLE_DAMAGES_BEFORE_ACCIDENT.YES
                }
              >
                <MultiSelectDamageBeforeAccident />
              </ConditionalRender>
            </Card>
          </ConditionalRender>
          <ConditionalRender
            when={(val) =>
              val.unrepairable_damages_before_accident ===
                UNREPAIRABLE_DAMAGES_BEFORE_ACCIDENT.NO ||
              val.damages_before_accident?.length > 0
            }
          >
            <Card>
              <RadioGroupPreAccidentRepairs />
              <ConditionalRender
                when={(val) =>
                  val.repairs_before_accident === REPAIRS_BEFORE_ACCIDENT.YES
                }
              >
                <SelectOriginalPartsUsedForRepair />
              </ConditionalRender>
              <ConditionalRender
                when={(val) => val.original_parts_used_for_repair_detailed}
              >
                <MultiSelectBeforeAccidentRepaired />
              </ConditionalRender>
            </Card>
          </ConditionalRender>
        </>
      )}
    </>
  );
};
export default SurveyOnePartTwo;
